import { Contract, SharedProps } from '@/types'
import { router, usePage } from '@inertiajs/react'
import { Button, Group, Modal, Stack, Text } from '@mantine/core'

export default function MissingEmailModal({ contract, onClose }: { contract: Contract | null; onClose: () => void }) {
  const { current_organization } = usePage<SharedProps>().props

  const handleSetupEmail = () =>
    router.get(`/organizations/${current_organization?.slug}/contracts/${contract?.id}/edit`)

  return (
    <Modal opened={contract !== null} onClose={onClose} title="Adresse email manquante" centered>
      <Stack gap="lg">
        <Text size="sm">
          La société « {contract?.customer_name} » n'a pas d'adresse email enregistrée. Ajoutez-en une pour pouvoir lui
          envoyer le récapitulatif par email.
        </Text>
        <Group justify="flex-end" gap="sm">
          <Button variant="default" onClick={onClose}>
            Annuler
          </Button>
          <Button onClick={handleSetupEmail}>Ajouter un email</Button>
        </Group>
      </Stack>
    </Modal>
  )
}
